import { ensureMicrofrontend } from '../../../utils/ensureMicrofrontend';

export async function openDatesPopup(): Promise<void> {
  const microfrontend = await ensureMicrofrontend('desktop-filters-micro-frontend');

  return microfrontend?.call('/v1/open-dates-popup');
}
